import { ButtonHTMLAttributes } from 'react';

type ButtonVariant = 'default' | 'line';
type Mode = 'primary' | 'secondary';
type ButtonClassSet = Record<ButtonVariant, Record<Mode, string>>;

interface ActionButtonProps {
  variant?: ButtonVariant;
  mode?: Mode;
}

export const ActionButton = ({
  children,
  className,
  variant = 'default',
  mode = 'primary',
  ...attr
}: ButtonHTMLAttributes<HTMLButtonElement> & ActionButtonProps) => {
  const baseClassList =
    'transition-all ease duration-150 cursor-pointer px-regular min-h-[60px] min-w-[220px] rounded-md border-1 pt-[11px] pb-[10px] text-center font-bold';
  const variantClassSet: ButtonClassSet = {
    default: {
      primary:
        'border-primary bg-primary text-neutral active:bg-primary-400 active:border-primary-400 hover:shadow-primary/20 hover:shadow-xl active:shadow-none',
      secondary: 'border-secondary bg-secondary text-neutral  hover:bg-secondary-400 hover:border-secondary-400',
    },
    line: {
      primary:
        'border-1 border-dark-100 text-dark-200 hover:border-primary active:bg-background-300 hover:shadow-xl hover:shadow-primary/20',
      secondary: 'border-secondary text-dark hover:bg-secondary-200 hover:text-secondary',
    },
  };

  const classSet = [baseClassList, variantClassSet[variant][mode], className].join(' ');

  return (
    <button className={classSet} {...attr}>
      {children}
    </button>
  );
};
